import React, { FC } from 'react'
import { List, ListItem, ListItemText, Typography } from '@material-ui/core'

export const ListItemRenderer: FC = ({ children }) => {
  return (
    <ListItem>
      <ListItemText disableTypography>
        <Typography variant="body2">&bull; {children}</Typography>
      </ListItemText>
    </ListItem>
  )
}

export const ListRenderer: FC = ({ children }) => {
  return <List disablePadding>{children}</List>
}
